<template>
  <div>
    <!-- 主体 -->
    <el-collapse-item :title="name" :name="name" class="entity-alarm-setting-item">

      <!-- title -->
      <template slot="title">
        <div class="title-left">{{name}}</div>
        <div class="title-right"><el-switch @click.stop.native="switchStatusToggle" class="switch" :class="{'el-switch-core':switchStatus===false }" v-model="switchStatus"></el-switch> <i class="el-icon-caret-bottom" :class="{'active-icon':switchStatus===false }"></i></div>
      </template>

      <!-- 告警类别 -->
      <div class="row alarm-types">
        <div class="row left-container">
          <div class="label alarm-categories"><img src="@/assets/img/exclamation-point.svg" class="img-alarm"> 告警类别 
            <el-popover
              placement="right"
              title
              width="300"
              trigger="hover"
              :visible-arrow=false
              content="您可依据需求，选取需要告警的负面舆情类别。类别被选取时，当该类别出现负面新闻，就会通过您设置的告警方式给您告警。类别告警一天告警一次。">
              <img class="img" slot="reference" src="@/assets/img/question-circle.svg"/>
            </el-popover>
            </div>
          <div><span class="alarm-categories-items" v-for="(item, index) in categories" :key="index">{{item}}</span></div>
        </div>
        <div class="divider"></div>
        <el-button class="right-container" @click="categoriesDialogVisible=true">编辑</el-button>
      </div>

      <!-- 告警阈值 -->
      <div class="row alarm-types">
        <div class="left-container">
          <div class="label alarm-threshold"><img src="@/assets/img/warning.svg" class="img-alarm"> 告警阈值 
            <el-popover
              placement="right"
              title
              width="400"
              trigger="hover"
              :visible-arrow=false
              content="告警阈值指的是当负面舆情指数出现达到阈值时，通过您设置的告警方式给您告警。系统默认告警阈值为“智能阈值”，“智能阈值”是结合负面舆情指数峰值、中位数、增长趋势、历史数据等情况通过算法模型计算得出，您不需要进行另外的设置。您也可以自定义告警阈值，设置“负面舆情指数”或“负面新闻条数”达到自定义值得时候，通过您设置的告警方式给您告警。">
              <img class="img" slot="reference" src="@/assets/img/question-circle.svg"/>
            </el-popover>
            </div>
          <div class="alarm-threshold-content" v-if="threshold.type==='automatic'">智能阈值</div>
          <div class="alarm-threshold-content" v-else-if="threshold.type==='custom'">
            {{threshold.value.val}}
            <span v-if="threshold.value.key==='count'">条</span>
          </div>
        </div>
        <div class="divider"></div>
        <el-button class="right-container" @click="thresholdDialogVisible=true">编辑</el-button>
      </div>
    </el-collapse-item>
    
    <!-- 告警类别 编辑 dialog -->
    <el-dialog :title="name" :visible.sync="categoriesDialogVisible" :before-close="done => done()">
      <alarm-category
        :filters="filters"
        :name="name"
        @change="onCategoriesChange"
      ></alarm-category>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="cancelCategories">取 消</el-button>
        <el-button class="confirm-btn" @click="categoriesDialogConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 告警阈值 编辑 dialog -->
    <el-dialog :title="name" :visible.sync="thresholdDialogVisible" :before-close="done => done()">
      <threshold-alarm-setting
        :radio-data="threshold.type"
        :option-data="threshold.value.key"
        :input-data="threshold.value.val"
        @radioChange="radioChange"
        @optionChange="optionChange"
        @inputChange="inputChange"
      ></threshold-alarm-setting>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="cancelThreshold">取 消</el-button>
        <el-button class="confirm-btn" @click="thresholdDialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AlarmCategory from '@/components/news-monitor/AlarmCategory';
import ThresholdAlarmSetting from '@/components/common/ThresholdAlarmSetting';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      categoriesDialogVisible: false,
      thresholdDialogVisible: false,
      switchStatus: true,
      categoriesData: [],
      thresholdData: {}
    };
  },
  watch: {
    categories(val) {
      this.categoriesData = val;
    },
    threshold(val) {
      this.thresholdData = val;
    }
  },
  props: {
    name: {
      // 公司名
      type: String,
      required: false,
      default: 'test name'
    },
    categories: {
      type: Array,
      required: false,
      default: () => []
    },
    threshold: {
      type: Object,
      required: false,
      default: () => {
        return {
          type: 'automatic'
        };
      }
    },
    status: {
      // 开关状态
      type: String,
      required: false,
      default: 'on'
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.switchStatus = this.status === 'on';
      this.categoriesData = this.categories;
      this.thresholdData = this.threshold;
    },
    async handelCompanyAlarmSetting() {
      const switchStatus = this.switchStatus ? 'on' : 'off';
      const companyAlarmSettings = {
        name: this.name,
        status: switchStatus,
        categories: this.categoriesData,
        threshold: {
          type: this.thresholdData.type,
          value: {
            key: this.thresholdData.value.key,
            val: this.thresholdData.value.val
          }
        }
      };
      const res = await QuestionQuery.putCompanyAlarmSetting(companyAlarmSettings);
      if (!res) {
        this.$message.error('修改失败');
      }
      this.categoriesDialogVisible = false;
      this.thresholdDialogVisible = false;
      this.$emit('refresh');
    },
    cancelCategories() {
      this.categoriesDialogVisible = false;
      this.$emit('refresh');
    },
    cancelThreshold() {
      this.thresholdDialogVisible = false;
      this.$emit('refresh');
    },
    categoriesDialogConfirm() {
      this.handelCompanyAlarmSetting();
    },
    thresholdDialogConfirm() {
      this.handelCompanyAlarmSetting();
    },
    switchStatusToggle() {
      this.handelCompanyAlarmSetting();
    },
    handleClose(done) {
      done();
    },
    onCategoriesChange(evt) {
      this.categoriesData = evt;
    },
    radioChange(evt) {
      this.thresholdData.type = evt;
    },
    optionChange(evt) {
      this.thresholdData.value.key = evt;
    },
    inputChange(evt) {
      this.thresholdData.value.val = Number(evt);
    }
  },
  computed: {
    filters() {
      return {
        negative: this.categoriesData
      };
    }
  },
  components: {
    AlarmCategory,
    ThresholdAlarmSetting
  }
};
</script>

<style lang="scss" scoped>
.title-left {
  font-size: 14px;
}
.entity-alarm-setting-item {
  padding: 0 24px;
  box-sizing: border-box;
  border-top: 1px solid #00000033;
  color: #ffffff;
  border-radius: 0 0 8px 8px;
  font-size: 14px;
  background-color: #3b3a3f !important;
  .el-button {
    color: #45a8cc;
    border-radius: 2px;
    border: solid 1px #605e61;
    background-color: transparent;
    &:hover {
      background-color: rgba(255, 255, 255, 0.08);
    }
  }
  .alarm-types {
    padding: 0 24px;
    .img {
      width: 14px;
      vertical-align: middle;
      margin-left: 4px;
      opacity: .3;
    }
    .img-alarm {
      width: 14px;
      vertical-align: middle;
    }
  }
  /deep/ {
    .el-collapse-item__arrow.el-icon-arrow-right {
      display: none;
    }
    .el-collapse-item__wrap {
      color: #ffffff;
      border: none;
      border-radius: 8px;
      background-color: #3b3a3f;
    }
    .el-collapse-item__header {
      justify-content: space-between;
      color: #ffffff;
      height: 48px;
      border: none;
      border-radius: 0 0 8px 8px;
      background-color: #3b3a3f;
      .el-icon-caret-bottom {
        transform: rotate(0deg);
      }
      .active-icon {
        color:#bbbaba;
      }
      .switch {
        margin-right: 26px;
      }
      .el-switch-core .el-switch__core{
        border:1px solid transparent;
        background-color: #646367;
      }
    }
    .el-collapse-item__content {
      padding: 0;
      color: #ffffff;
      border-radius: 8px;
      font-size: 14px;
      .alarm-types {
        padding: 12px 24px;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #00000033;
        box-sizing: border-box;
        .left-container {
          flex: 1;
          flex-direction: column;
          .label {
            &.alarm-categories {
              color: #54cea4;
            }
            &.alarm-threshold {
              color: #ef711a;
            }
          }
          .alarm-categories-items {
            display: inline-block;
            margin-right: 24px;
          }
        }
        .divider {
          margin: 0 16px;
          height: 32px;
          width: 1px;
          background-color: #ffffff;
          opacity: .1;
        }
        .right-container {
          padding: 0;
          width: 52px;
          height: 32px;
        }
      }
    }
  }
  &.is-active {
    /deep/ {
      .el-collapse-item__header {
        .el-icon-caret-bottom {
          transform: rotate(-180deg);
        }
      }
      .el-collapse-item__content {
        .alarm-types {
          padding: 12px 24px;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #00000033;
          box-sizing: border-box;
          .left-container {
            flex: 1;
            flex-direction: column;
            .label {
            }
          }
          .divider {
            margin: 0 16px;
            height: 32px;
            width: 1px;
            background-color: #ffffff;
            opacity: .1;
          }
          .right-container {
            padding: 0;
            width: 52px;
            height: 32px;
          }
        }
      }
    }
  }
}
/deep/ {
  .el-dialog__wrapper {
    .el-dialog {
      width: 760px;
      color: #ffffff;
      background-color: #333138;
      .el-dialog__header {
        .el-dialog__title {
          color: #ffffff;
        }
      }
    }
  }
}
.cancel-btn {
  height: 48px;
  width: 99px;
  padding: 0;
  font-size: 16px;
  color: #ffffff;
  background-color: #3b3a3f;
  border-radius: 2px;
  border: none;
  &:hover {
    color: #ffffff;
    background-color: #423f43;
  }
  &:focus {
    color: #ffffff;
    background-color: #423f43;
  }
  &:active {
    color: #ffffff;
    background-color: #38363c;
  }
}
.confirm-btn {
  height: 48px;
  width: 99px;
  padding: 0;
  font-size: 16px;
  color: #ffffff;
  background-color: #45a8cc;
  box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
  border-radius: 2px;
  border: none;
  &:hover {
    color: #ffffff;
    background-color: #3cbeed;
  }
  &:focus {
    color: #ffffff;
    background-color: #3cbeed;
  }
  &:active {
    color: #ffffff;
    background-color: #368cab;
  }
}
</style>
